import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const SingleOpenTooltip = props => /*#__PURE__*/_jsx(UITooltip, Object.assign({
  "data-test-id": "save-disabled-drop"
}, props, {
  className: "save-disabled-drop",
  maxWidth: 250
}));
export default SingleOpenTooltip;